import { render, staticRenderFns } from "./RingTwo.vue?vue&type=template&id=4b238aca&scoped=true&"
import script from "./RingTwo.vue?vue&type=script&lang=js&"
export * from "./RingTwo.vue?vue&type=script&lang=js&"
import style0 from "./RingTwo.vue?vue&type=style&index=0&id=4b238aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b238aca",
  null
  
)

export default component.exports